import { render } from "./section.vue?vue&type=template&id=354813ac&scoped=true&ts=true"
import script from "./section.vue?vue&type=script&lang=ts"
export * from "./section.vue?vue&type=script&lang=ts"

import "./section.vue?vue&type=style&index=0&id=354813ac&scoped=true&lang=css"

import exportComponent from "G:\\Coding_Projects\\cv2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354813ac"]])

export default __exports__